import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { useApi } from "@/lib/api";
import { StatCard, PageTitle } from "@/components/Bits";
import SessionTable from "@/components/SessionTable";

export default function AdminOverview() {
  const api = useApi();
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);
  useEffect(() => {
    api("get", "/admin/stats").then(setStats);
    api("get", "/admin/sessions").then((r) => setRecent(r.slice(0, 8)));
  }, [api]);
  const o = stats?.overall;
  return (
    <div className="fade-up" data-testid="admin-overview-page">
      <PageTitle kicker="Super admin" title="Assessment control room" />
      <div className="grid grid-cols-2 lg:grid-cols-6 gap-4 mb-8">
        <StatCard label="Users" value={o?.users ?? "-"} testid="admin-stat-users" />
        <StatCard label="Sessions" value={o?.total ?? "-"} accent="text-blue-400" testid="admin-stat-sessions" />
        <StatCard label="Passed" value={o?.passed ?? "-"} accent="text-emerald-500" testid="admin-stat-passed" />
        <StatCard label="Failed" value={o?.failed ?? "-"} accent="text-rose-500" testid="admin-stat-failed" />
        <StatCard label="Pass rate" value={o ? `${o.pass_rate}%` : "-"} testid="admin-stat-pass-rate" />
        <StatCard label="Avg score" value={o?.average_score ?? "-"} testid="admin-stat-avg" />
      </div>
      <div className="grid lg:grid-cols-12 gap-4 mb-10">
        <div className="lg:col-span-8 bg-slate-900 border border-slate-800 p-6" data-testid="admin-daily-chart">
          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-slate-500 mb-4">Last 14 days</p>
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={stats?.daily || []}>
              <CartesianGrid stroke="#1e293b" vertical={false} />
              <XAxis dataKey="date" stroke="#64748b" fontSize={11} />
              <YAxis allowDecimals={false} stroke="#64748b" fontSize={11} />
              <Tooltip contentStyle={{ background: "#0f172a", border: "1px solid #1e293b" }} cursor={{ fill: "#1e293b" }} />
              <Legend />
              <Bar dataKey="passed" stackId="a" fill="#10b981" name="Passed" />
              <Bar dataKey="failed" stackId="a" fill="#f43f5e" name="Failed" />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="lg:col-span-4 bg-slate-900 border border-slate-800 p-6" data-testid="admin-role-breakdown">
          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-slate-500 mb-6">By team type</p>
          <div className="space-y-6">
            {(stats?.by_role || []).map((r) => (
              <div key={r.role}>
                <div className="flex justify-between text-sm"><span className="text-white">{r.role}</span><span className="font-mono text-slate-400">{r.total} · {r.pass_rate}%</span></div>
                <div className="h-1.5 bg-slate-800 mt-2"><div className="h-full bg-emerald-500" style={{ width: `${r.pass_rate}%` }} /></div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-slate-500 mb-3">Most recent responses</p>
      <SessionTable sessions={recent} showUser basePath="/admin/sessions" />
    </div>
  );
}
